var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale2E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 127,
    viewBox: "0 0 129 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Male 2 E"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 106",
    cx: 60.0357,
    cy: 61.5,
    rx: 60.0357,
    ry: 61.5,
    fill: "#E0DDFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 1",
    filter: "url(#filter0_f_297_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 13.5L114 35.5L117.396 48.1802C124.263 73.8136 113.281 100.89 90.5 114.5L68 107V13.5Z",
    fill: "#858181",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M81.7506 42.7115C81.8378 42.0079 81.8052 41.3176 81.7051 40.6871C81.3932 38.722 79.5548 38.5321 77.9811 39.7497C77.4314 40.175 76.9604 40.6934 76.5895 41.2813L75 43.8008L74.5 52.3008L74.5325 52.291C75.1409 52.108 75.8 52.225 76.3083 52.6062L76.849 53.0117C77.2353 53.3015 78.1067 53.0271 78.5402 52.8145C78.8694 52.6531 78.8053 52.5761 79.0075 52.2702L79.3264 51.788C79.4088 51.6634 79.4781 51.5306 79.5332 51.3918L80.2171 49.6682C80.6005 48.3799 81.4439 45.185 81.7506 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 97",
    d: "M34.5502 42.7115C34.463 42.0079 34.4955 41.3176 34.5956 40.6871C34.9076 38.722 36.746 38.5321 38.3197 39.7497C38.8694 40.175 39.3404 40.6934 39.7113 41.2813L41.3008 43.8008L41.8008 52.3008L41.7683 52.291C41.1599 52.108 40.5008 52.225 39.9925 52.6062L39.4518 53.0117C39.0655 53.3015 38.1941 53.0271 37.7606 52.8145C37.4313 52.6531 37.4955 52.5761 37.2933 52.2702L36.9744 51.788C36.892 51.6634 36.8227 51.5306 36.7676 51.3918L36.0837 49.6682C35.7003 48.3799 34.8569 45.185 34.5502 42.7115Z",
    fill: "#F4B09D",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 93",
    d: "M44.8535 76.8356V63.5371L71.3061 63V65.1659V71.8114V77.6086V80.1898C71.3061 81.301 71.2069 82.4099 71.0097 83.5034L70.9004 84.1092C70.6609 85.4372 70.2351 86.7247 69.6355 87.9336L69.3332 88.5431C68.6124 89.9964 67.5853 91.2763 66.3225 92.2947C65.0595 93.3133 63.5907 94.0462 62.0172 94.4427L61.4343 94.5896C60.3522 94.8623 59.2406 95.0003 58.1247 95.0003H57.4498C55.4777 95.0003 53.5414 94.4731 51.8414 93.4734C50.5198 92.6962 49.3741 91.6528 48.4771 90.4094L47.8594 89.5531C47.1358 88.5502 46.5318 87.4663 46.0594 86.3234C45.2632 84.3971 44.8535 82.3332 44.8535 80.2489V76.8356Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 90",
    d: "M41.0427 55.1641L40.6716 53.8279C40.1382 51.9074 39.7542 49.9484 39.5232 47.9686L39.1035 44.3726V40.1213V39.7978C39.1035 36.6692 39.36 33.5459 39.8703 30.4593L40.637 27.7539L40.854 26.806C41.4639 24.1417 42.8073 21.7012 44.7321 19.7607C45.577 18.909 46.5233 18.1644 47.5497 17.5435L47.7675 17.4118C50.3759 15.834 53.3662 15 56.4147 15H58.2721H62.7371C64.3491 15 65.9494 15.274 67.4696 15.8104C70.9169 17.0268 73.7635 19.5238 75.4187 22.7832L75.7025 23.3422C76.0938 24.1128 76.4212 24.9142 76.6814 25.7383L76.9381 26.5516C77.9693 29.8187 78.3487 33.2566 78.0547 36.6699L77.824 39.3483L76.6739 50.9428L76.2905 53.6481C75.526 56.7309 74.4285 59.7213 73.0173 62.5666L72.8401 62.9237L70.3494 66.5506C69.7118 67.4792 68.9705 68.3322 68.1401 69.0933C66.1969 70.8742 63.8149 72.1061 61.2384 72.6627L60.8635 72.7437C60.1602 72.8956 59.4427 72.9722 58.7232 72.9722C55.4664 72.9722 52.32 71.7914 49.8675 69.6485L49.2356 69.0965C48.3619 68.3332 47.5756 67.4753 46.891 66.5387L45.8859 65.1636C43.6827 62.1492 42.0419 58.7616 41.0427 55.1641Z",
    fill: "#F6C4A9",
    stroke: "#4F4848"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9128 60.2453L52.9068 61.762H62.8745L61.0594 60.1936C60.49 59.7016 59.8033 59.365 59.0656 59.2163C58.5423 59.1107 58.0041 59.102 57.4776 59.1905L57.2855 59.2227C56.4238 59.3675 55.6098 59.7183 54.9128 60.2453Z",
    fill: "url(#paint0_linear_297_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9068 61.762L54.9128 60.2453C55.6098 59.7183 56.4238 59.3675 57.2855 59.2227L57.4776 59.1905C58.0041 59.102 58.5423 59.1107 59.0656 59.2163V59.2163C59.8033 59.365 60.49 59.7016 61.0594 60.1936L62.8745 61.762H52.5234",
    stroke: "#4F4848",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 94",
    d: "M55.5898 54.0332V54.0332C56.9467 55.7919 59.6002 55.7919 60.957 54.0332V54.0332",
    stroke: "#4F4848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 96",
    d: "M56.3535 63.3105L56.533 63.4915C57.4573 64.4233 58.988 64.3386 59.8039 63.3105V63.3105",
    stroke: "#4F4848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 109",
    d: "M80.8828 43.7169C80.8828 44.2692 80.3828 42.7168 79.8828 42.7175C79.3828 42.2168 78.748 42.2684 78.748 41.7161C78.748 41.1638 79.3828 40.717 79.8828 41.2174C80.4351 41.2174 80.8828 43.1646 80.8828 43.7169Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 110",
    d: "M77.5409 50.7164C77.3825 50.2168 77.7246 47.8711 77.8828 46.7168C77.8828 45.3711 78.5409 43.7168 79.0409 43.7168C80.0026 43.7168 79.9499 45.2251 79.7443 46.1645C79.329 48.0619 78.1838 50.7167 77.5409 50.7164Z",
    fill: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 116",
    d: "M38.4453 43.136C38.4453 47.6367 39.9453 49.6367 39.9449 50.636C39.4453 51.6367 36.9449 46.9122 36.9449 46.636C36.9449 46.3599 35.9436 43.6366 36.9453 42.136C37.9436 41.6365 38.447 42.6368 38.4453 43.136Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 113",
    opacity: 0.5,
    filter: "url(#filter1_f_297_486)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62.5,
    rx: 1,
    ry: 0.5,
    fill: "#DC2F2F",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M71 66.0399C71 69.4867 67.2529 74.6671 61.0436 77.0586C58.9248 77.8746 56.5564 77.9135 54.433 77.1097C47.6976 74.5599 45 68.4954 45 65C46.0196 66.1774 50.6078 73.0842 57.2353 73.3194C64.8824 73.5909 68.9608 69.1597 71 66.0399Z",
    fill: "#655E5E",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 114",
    filter: "url(#filter2_f_297_486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 94.9997C106 106 84.2978 123 60.1502 123C36.0026 123 17 107.501 10 93.0014C59 69.5 32.5 71.0009 57.5 93.0009C84 74.4997 52.5 67.4997 109 94.9997Z",
    fill: "#1F1F1F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.5 78.5895L75.8603 78L57.5009 89.6055L39.1397 78L36 78.5895C36.2856 85.3342 37.4938 91.965 39.6245 98.4835C41.6143 103.609 44.1096 108.565 47.1103 113.35C50.111 118.137 53.5739 122.687 57.5009 127C61.4261 122.687 64.8909 118.137 67.8897 113.35C70.8904 108.565 73.3857 103.609 75.3774 98.482C77.5062 91.965 78.2144 85.3327 78.5 78.5895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5646 77.9825L42.7237 74.17C43.291 73.6499 44.2086 73.9388 44.3756 74.6902L44.9497 77.2735C44.9828 77.4225 45.0496 77.562 45.145 77.6812L51 85L57.5 89.5L63.5 85L71.2747 77.7112C71.4215 77.5736 71.5233 77.395 71.567 77.1986L72.0815 74.8832C72.2574 74.0918 73.2523 73.8276 73.7976 74.4274L77.0173 77.969C77.3058 78.2864 77.3598 78.7524 77.1515 79.1273L70.6848 90.7674C70.3502 91.3697 69.521 91.4611 69.0632 90.9461L66 87.5L57.5 93.5L48.8571 87.5L45.9647 90.8745C45.5033 91.4128 44.644 91.3134 44.3177 90.6841L38.3526 79.1799C38.1445 78.7787 38.2314 78.2878 38.5646 77.9825Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 85L48.8571 87.5M51 85L57.5 89.5M51 85L45.145 77.6812C45.0496 77.562 44.9828 77.4225 44.9497 77.2735L44.3756 74.6902C44.2086 73.9388 43.291 73.6499 42.7237 74.17L38.5646 77.9825C38.2314 78.2878 38.1445 78.7787 38.3526 79.1799L44.3177 90.6841C44.644 91.3134 45.5033 91.4128 45.9647 90.8745L48.8571 87.5M48.8571 87.5L57.5 93.5M57.5 93.5L66 87.5M57.5 93.5V89.5M66 87.5L69.0632 90.9461C69.521 91.4611 70.3502 91.3697 70.6848 90.7674L77.1515 79.1273C77.3598 78.7524 77.3058 78.2864 77.0173 77.969L73.7976 74.4274C73.2523 73.8276 72.2574 74.0918 72.0815 74.8832L71.567 77.1986C71.5233 77.395 71.4215 77.5736 71.2747 77.7112L63.5 85M66 87.5L63.5 85M63.5 85L57.5 89.5",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63 122.5H53.5C53.8043 108.811 56.6835 100.945 56.6835 100.945C56.547 100.885 56.3205 100.626 56.0543 100.251V100.25C56.472 100.315 57.0342 100.349 57.5733 100.349C58.3294 100.349 59.0364 100.281 59.2179 100.129C59.4799 99.9075 61.3851 92.727 62.0538 91L63.5 90C62.8531 91.5944 60.584 100.749 60.352 100.945L60.3206 100.968C60.4612 101.525 62.7038 109.103 63 122.5Z",
    fill: "#D0C5D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.5 122.5H53.5C53.6465 111.19 56.2613 101 56.2613 101H59.1723L59.1778 101.015C59.2871 101.465 62.3557 111.422 62.5 122.5Z",
    fill: "#15355E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.5 91C53.5 91 55.6432 100.625 56.1902 100.832C56.7359 101.039 58.9851 101.072 59.306 100.832C59.627 100.592 61.8065 91.9279 62 91C61.5 90.9992 57.5 94 57.5 94L53.5 91Z",
    fill: "#15355E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.3725 33.3349C80.4789 26.9079 79.701 20.9904 77.4981 16.229C76.5189 17.7163 75.522 19.196 74.4948 20.6499C73.7701 25.0831 72.9168 30.0052 75.1476 34.0956C76.2531 36.1237 77.7189 37.7081 77.83 40.157C77.8509 40.6144 77.7659 41.1178 77.6453 41.6376C77.6895 41.5977 77.7298 41.5538 77.7702 41.5098C78.3208 39.1181 78.8281 36.4921 79.3725 33.3349Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.1984 36.8241C40.6795 35.3513 41.3826 33.9642 42.4553 32.8672C43.5842 31.7133 45.069 30.9248 45.9166 29.5254C46.5412 28.4943 46.7507 27.2476 46.8671 26.0267C47.0824 23.7788 47.0358 21.5011 46.7294 19.2626C46.5199 17.7299 46.5257 15.415 45.2038 14.4645C44.4435 13.9154 43.4241 13.8855 42.5581 14.2055C41.692 14.5244 40.9549 15.156 40.3139 15.8578C38.2849 18.0788 37.0775 21.1316 37.0028 24.2278C36.9281 27.3632 38.3722 31.5699 38.3131 34.5897C38.2781 36.3359 38.3189 38.0749 38.4159 39.8171C38.4595 40.6056 38.4159 41.2733 38.3383 42.0288C38.2723 42.6366 38.3664 43.4282 38.5478 44C39.698 43.0195 39.4012 40.0101 39.729 38.5332C39.8638 37.9583 40.0171 37.3866 40.1984 36.8241Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.5258 8.54524C44.7402 10.7793 44.4732 14.6575 45.6863 17.8685C48.0787 24.1956 55.4347 28.6539 61.3044 30.8912C61.7312 31.0526 66.678 32.4482 66.6853 32.2933C66.7631 30.2621 66.6643 28.5307 68.7183 30.382C69.8903 31.4396 71.2159 32.314 72.6318 32.978C73.3403 33.3084 74.0719 33.593 74.8171 33.811C75.8546 34.1098 75.8883 34.1414 76.4675 33.2517C78.2744 30.4703 78.9514 26.5212 78.9987 23.2328C79.0701 18.4376 76.2783 12.0048 71.0256 11.3593C69.8903 11.2187 68.8129 11.4466 67.6377 11.1555C67.4411 11.1064 67.1931 10.9265 67.3087 10.7542C69.4772 10.5122 71.5785 9.62029 73.2898 8.21488C69.267 8.55179 65.1569 8.37625 61.1447 8.10258C56.96 7.81364 51.2942 5.52399 47.5258 8.54524Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M53.864 37.4929C54.7124 37.8436 55 36.2702 55 36.2702C55 34.3873 53.7964 34.3873 53.7964 34.3873L47.6363 34.0001C47.6363 34.0001 44.4124 33.9235 44 38C44 38 44.6918 36.7451 47.6363 36.9027L53.864 37.4929Z",
    fill: "#351F17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M62.136 37.4929C61.2876 37.8436 61 36.2702 61 36.2702C61 34.3873 62.2036 34.3873 62.2036 34.3873L68.3637 34.0001C68.3637 34.0001 71.5876 33.9235 72 38C72 38 71.3082 36.7451 68.3637 36.9027L62.136 37.4929Z",
    fill: "#351F17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M49 41.9967C48.9978 43.1014 49.4438 43.9972 49.9957 44C50.549 44.0028 50.9978 43.107 51 42.0014C51.0029 40.8996 50.5569 40.0009 50.0036 40C49.4517 39.9981 49.0022 40.8912 49 41.9967Z",
    fill: "#431F10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M67 41.9967C67.0022 43.1014 66.5562 43.9972 66.0043 44C65.451 44.0028 65.0022 43.107 65 42.0014C64.9971 40.8996 65.4431 40.0009 65.9964 40C66.5483 39.9981 66.9978 40.8912 67 41.9967Z",
    fill: "#431F10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M26 84L24.0159 92.8995L31.2788 96.8472L29.7993 104.956L51.4963 119.396C44.8695 112.336 38.7973 91.8743 37.4999 78.001L26 84Z",
    fill: "#343D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M82.9499 98.0305L90.2187 93.9994L87.5 83.5L78.0001 78.5009C76.6848 92.6336 69.3377 113.826 62.7024 121.026L84.4205 106.288L82.9499 98.0305Z",
    fill: "#343D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_297_486",
    x: 67,
    y: 12.5,
    width: 53.4238,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_297_486"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_297_486",
    x: 56.6,
    y: 61.6,
    width: 2.8,
    height: 1.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_297_486"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_297_486",
    x: 9,
    y: 74.9336,
    width: 101,
    height: 49.0664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_297_486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_486",
    x1: 58.274,
    y1: 59.4431,
    x2: 58.274,
    y2: 62.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D1111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale2E);
export default __webpack_public_path__ + "static/media/Male 2 E.370b5fd77414361bf362ab61a549d0a7.svg";
export { ForwardRef as ReactComponent };